import React, { useContext } from 'react';
import { UserContext } from 'components/App';
import { isUserHyperAdmin, isUserSuperAdmin } from 'services/security/accessServices';
import PointConversionPage from './PointConversionPage';
import SuperAdminWinsPage from './SuperAdminWinsPage';

const WinsHistoryPage = () => {
  const { userData } = useContext(UserContext);
  if (isUserHyperAdmin(userData?.highestRole)) return <PointConversionPage />;
  if (isUserSuperAdmin(userData?.highestRole)) return <SuperAdminWinsPage />;
  return null;
};

export default WinsHistoryPage;
